<template>
  <div>
    <BillDetails
      v-intersect="onIntersect"
      :bill="selectedBill"
      :billStub="billStub"
      :loading="loading"
      :trackedBill="trackedBill"
      :isExtended="isExtended"
      @refreshTrackedBills="refreshTrackedBills"
      @refresh="refreshBillDetails"
    >
      <template v-slot:tracker>
        <TrackerDetails :trackedBill="trackedBill"></TrackerDetails>
      </template>
    </BillDetails>
  </div>
</template>
<script>
import { get, sync, commit, call } from 'vuex-pathify'
import dayjs from 'dayjs'
import relativeTime from 'dayjs/plugin/relativeTime'
dayjs.extend(relativeTime)
import BillDetails from '@components/lso/BillDetails'
import TrackerDetails from '@components/lso/TrackerDetails'
import download from 'downloadjs'
export default {
  //model: {
  //	prop: ''
  //},
  props: {
    trackedBill: { type: Object, required: true },
    isExtended: { type: Boolean, default: false },
  },
  components: {
    BillDetails,
    TrackerDetails,
  },
  filters: {},
  data() {
    return {
      dayjs,
      selectedBill: {},
      loadingCount: 0,
      isIntersecting: false,
    }
  },
  mounted() {
    this.loadBillDetails()
  },
  computed: {
    ...get('bills', ['billDetails']),
    loading() {
      return this.loadingCount > 0
    },
    billStub() {
      return {
        bill: this.trackedBill.BillNumber,
        catchTitle: this.trackedBill.ShortTitle,
        specialSessionValue: this.trackedBill.SpecialSession,
        sponsor: this.trackedBill.Sponsor,
        billType: this.trackedBill.BillType,
        billStatus: this.trackedBill.LsoBillStatus,
        effectiveDate: null,
        signedDate: null,
        lastAction: this.trackedBill.LsoLastAction,
        lastActionDate: this.trackedBill.LsoLastActionDate,
        enrolledNumber: null,
        chapter: null,
        year: this.trackedBill.Year,
      }
    },
    payload() {
      if (this.trackedBill) {
        return {
          year: this.trackedBill.Year,
          billNum: this.trackedBill.BillNumber,
          specialSessionValue: this.trackedBill.SpecialSession,
        }
      } else {
        return null
      }
    },
    hasDetails() {
      let hasDetails = false
      if (this.trackedBill.CreatedBy != null) {
        return true
      }
      if (this.trackedBill.UpdatedBy != null) {
        return true
      }
      if (this.trackedBill.Assignments?.length > 0) {
        return true
      }
      if (this.trackedBill.Concern != null) {
        return true
      }
      if (this.trackedBill.Priority != null) {
        return true
      }
      if (this.trackedBill.Position != null) {
        return true
      }
      return hasDetails
    },
    recentActivity() {
      var combined = this.trackedBill.Comments.concat(
        this.trackedBill.Links.map((item) => {
          return {
            ...item,
            link: item.URL.startsWith('http') ? item.URL : 'http://' + item.URL,
          }
        })
      )
        .concat(this.trackedBill.Documents)
        .sort((a, b) => new Date(b.CreatedDate) - new Date(a.CreatedDate))
      if (combined.length > 0) {
        return combined[0]
      } else {
        return null
      }
    },
  },
  methods: {
    ...call('bills', ['loadBill', 'getSelectedBill']),
    ...call('trackedBill', ['setBillDetails', 'loadTrackedBillCardDetails']),
    onIntersect(entries, observer) {
      // More information about these options
      // is located here: https://developer.mozilla.org/en-US/docs/Web/API/Intersection_Observer_API
      this.isIntersecting = entries[0].isIntersecting
    },
    getBillDetails() {
      this.loadingCount++
      this.getSelectedBill(this.payload).then(
        (res) => {
          this.selectedBill = res.data
          this.setBillDetails(res.data)
          this.loadingCount--
        },
        (err) => {
          this.loadingCount--
        }
      )
    },
    getTrackerDetails() {
      if (!this.isExtended && !this.hasDetails) {
        //load additional trackedbill details
        this.loadTrackedBillCardDetails(this.trackedBill.ID)
      }
    },
    loadBillDetails() {
      if (this.isIntersecting && !this.trackedBill.IsSummary) {
        this.getTrackerDetails()
      }
      if (this.trackedBill.BillNumber) {
        if (this.trackedBill.billDetails) {
          this.selectedBill = this.trackedBill.billDetails
        } else {
          let match = this.billDetails.find(
            (x) =>
              x.bill == this.payload.billNum &&
              x.year == this.payload.year &&
              x.specialSessionValue == this.payload.specialSessionValue
          )
          if (match) {
            this.selectedBill = match
            this.trackedBill.billDetails = match
          } else {
            if (this.isIntersecting) {
              this.getBillDetails()
            }
          }
        }
      }
    },
    refreshTrackedBills() {
      this.$emit('refreshTrackedBills')
    },
    refreshBillDetails() {
      this.selectedBill = {}
      this.getBillDetails()
    },
  },
  watch: {
    trackedBill(nval, oval) {
      this.loadBillDetails()
    },
    isIntersecting(nval, oval) {
      this.loadBillDetails()
    },
  },
}
</script>

<style scoped></style>
